import { createStore } from 'vuex'
import createMultiTabState from 'vuex-multi-tab-state';
import api from '../tools/api';


export default createStore({
  state: {
    page: {
     mainTitle: 'Innopearl Partner+',
     subTitle: ''
   },
   innotoken: '',
   refresh_token : "",
   notification: 0,
   isAuth: false,
   role: "",
   fullname : "",
   myProjects:[],
   myLinksPlus: [],
   customerlogo: '',
   affinityConfig:null,
   uid: null,
   loginFrom:null,
   droit_access_platform:null,
   pearlAICredit: 0,
   rankAICredit: 0,
  },

  getters: {
    affinityConfig: (store) => store.affinityConfig,
     authenticated: (store) => store.isAuth,
     role: (store) => store.role,
     fullname: (store) => store.fullname,
     customerlogo: (store) => store.customerlogo,
     myProjects: (store) => store.myProjects,
     myLinksPlus: (store) => store.myLinksPlus,
      loginFrom: (store) => store?.loginFrom,
      uid: (store) => store.uid,
      droit_access_platform: (store) => store.droit_access_platform,
      pearlAICredit: (store) => store.pearlAICredit,
      rankAICredit: (store) => store.rankAICredit
  },
  mutations: {
    UPDATE_PAGE_INFO(state, page){
      state.page = page;
    },
    UPDATE_ROLE(state, role){
      console.log("mutation");
      state.role = role;
         console.log(localStorage.getItem('innorole'));
       localStorage.setItem('innorole', role);
       console.log(localStorage.getItem('innorole'));
    },
    UPDATE_MYPROJECTS(state, project){
      state.myProjects = project;
    },
    UPDATE_MYLINKPLUS(state,project){
      state.myLinksPlus = project
    },
    UPDATE_PROJECTS(state, project){
      var objIndex = state.myProjects.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myProjects[objIndex] = project;
      }
      else{
          state.myProjects.push(project);
      }
    },
    UPDATE_LINKSPLUS(state, project){
      var objIndex = state.myLinksPlus.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myLinksPlus[objIndex] = project;
      }
      else{
          state.myLinksPlus.push(project);
      }
    },
    UPDATE_PROJECTS_REMOVE(state, project){
      var objIndex = state.myProjects.findIndex((obj => obj._id.$oid == project._id.$oid));
      if(objIndex != -1){
          state.myProjects.splice(objIndex, 1);
      }
    },
    UPDATE_LINKPLUS_REMOVE(state, project){
      var objIndex = state.myLinksPlus.findIndex((obj => obj._id.$oid == project));
      if(objIndex != -1){
          state.myLinksPlus.splice(objIndex, 1);
      }
    },
    UPDATE_NOTIFICATION(state,amount){
      console.log(amount);
      api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
        state.notification = (r.data) ? r.data.required : 0;
      }).catch( (e) => console.log(e));
    },
    UPDATE_DROIT_ACCESS_PLATFORM(state,valdroit){
      state.droit_access_platform = valdroit;
      localStorage.setItem("droit_access_platform",String(state.droit_access_platform));
    },
    UPDATE_PEARLAI_CREDIT(state, amount) {
      state.pearlAICredit = Number(amount) || 0;
      localStorage.setItem('pearlAICredit', String(state.pearlAICredit));
    },
    UPDATE_RANKAI_CREDIT(state, amount) {
      state.rankAICredit = Number(amount) || 0;
      localStorage.setItem('rankAICredit', String(state.rankAICredit));
    },
    LOGOSET (state,logoData) {
      if(logoData.$oid){
        state.customerlogo = logoData.$oid;
        localStorage.setItem('innologo', logoData.$oid);
      }
    },
    LOGIN (state,loginData) {
      console.log("loginData",loginData);
         state.innotoken = loginData.token.token;
         state.refresh_token = loginData.token.refresh_token;
         state.isAuth = true;
         state.role = loginData.role;
         state.fullname = loginData.fullname;
         state.uid = loginData.uid;
         state.affinityConfig = loginData.affinityConfig;
         state.loginFrom = loginData?.loginFrom;
         state.droit_access_platform = loginData.droit_access_platform ?? "full";
         state.pearlAICredit = Number(loginData.PearlAICredit ?? loginData.pearlAICredit ?? 0) || 0;
         state.rankAICredit = Number(loginData.RankAICredit ?? loginData.rankAICredit ?? loginData.RankAICredit ?? loginData.rankAICredit ?? 0) || 0;
         

         if(loginData.logo){
           state.customerlogo = loginData.logo.$oid;
           localStorage.setItem('innologo', loginData.logo.$oid);
         }
         else{
            state.customerlogo = null;
            localStorage.setItem('innologo', null);
         }
         localStorage.setItem("affinityConfig",JSON.stringify(loginData.affinityConfig));
         localStorage.setItem('innotoken', loginData.token.token);
         localStorage.setItem('refresh_token', loginData.token.refresh_token);
         localStorage.setItem('innorole', loginData.role);
              localStorage.setItem('innoname', loginData.fullname);
            localStorage.setItem('loginFrom', loginData?.loginFrom);
              localStorage.setItem('innouid', loginData.uid.$oid);
              localStorage.setItem("droit_access_platform",loginData.droit_access_platform);
              localStorage.setItem('pearlAICredit', String(state.pearlAICredit));
              localStorage.setItem('rankAICredit', String(state.rankAICredit));
         api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
           state.myProjects = r.data;
           console.log("myProjects",r);
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
           state.myLinksPlus = r.data;
           console.log("myLinksPlus",r);
         }).catch( (e) => console.log(e));
         api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
           state.notification = (r.data) ? r.data.required : 0;
         }).catch( (e) => console.log(e));
    },
    LOGOUT(state){
         state.refresh_token ="";
         state.innotoken ="";
         state.isAuth = false;
         state.role = "";
          state.fullname = "";
         state.notification = 0;
         state.customerlogo = null;
         state.uid = null;
         state.loginFrom = null;
         state.affinityConfig = null;
         state.droit_access_platform = null;
         state.pearlAICredit = 0;
         state.rankAICredit = 0;
         localStorage.removeItem("affinityConfig");
         localStorage.removeItem('refresh_token');
         localStorage.removeItem('innotoken');
         localStorage.removeItem('innouid');
         localStorage.removeItem('innorole');
         localStorage.removeItem('loginFrom');
         localStorage.removeItem('innologo');
         localStorage.removeItem('currentBasicFilterSet');
         localStorage.removeItem('currentFilterSet');
         localStorage.removeItem('droit_access_platform');
         localStorage.removeItem('pearlAICredit');
         localStorage.removeItem('rankAICredit');
         state.project = [];
    },
    INITIALISESTORE(state) {
         if(localStorage.getItem('innotoken')){
           state.innotoken = localStorage.getItem('innotoken');
           state.refresh_token = localStorage.getItem('refresh_token');
           state.role = localStorage.getItem('innorole');
            state.customerlogo = localStorage.getItem('innologo');
              state.fullname = localStorage.getItem('innoname');
              state.uid = localStorage.getItem('innouid');
                state.loginFrom = localStorage.getItem('loginFrom');
              state.affinityConfig = localStorage.getItem("affinityConfig");
              state.droit_access_platform = localStorage.getItem("droit_access_platform");
              state.pearlAICredit = Number(localStorage.getItem('pearlAICredit')) || 0;
              state.rankAICredit = Number(localStorage.getItem('rankAICredit')) || 0;
           state.isAuth = true;
           api.get(process.env.VUE_APP_API_URL+"/restrict/projects").then( (r) => {
             state.myProjects = r.data;
             console.log(r.data);
             console.log(r);
           }).catch( (e) => console.log(e));

           api.get(process.env.VUE_APP_API_URL+"/restrict/list_mylinkplus").then( (r) => {
             state.myLinksPlus = r.data;
             console.log("myLinksPlus",r);
           }).catch( (e) => console.log(e));


           api.get(process.env.VUE_APP_API_URL+"/restrict/projects_tasks").then( (r) => {
             state.notification = (r.data) ? r.data.required : 0;
           }).catch( (e) => console.log(e));
          }
      }
  },
  actions: {
    updateRole(context, page){
      console.log("action");
      context.commit('UPDATE_ROLE',page);
    },
    updateProjects(context, pro){
      console.log("updateProjects");
      context.commit('UPDATE_MYPROJECTS',pro);
    },
    updateLinkplus(context, pro){
      console.log("updateProjects");
      context.commit('UPDATE_MYLINKPLUS',pro);
    },
    updatePage(context, page){
      context.commit('UPDATE_PAGE_INFO',page);
    },
    updateNotification({ commit }, payload) {
      return new Promise((resolve) => {
        // Effectuer les opérations nécessaires pour mettre à jour la notification
        // ...

        // Déclencher la mutation pour mettre à jour le store
        commit('UPDATE_NOTIFICATION', payload);
        resolve();
      });
    }
  },
  modules: {
  },
  plugins: [
    createMultiTabState(),
  ],
})
